import { Box } from "@chakra-ui/react";
import { useConfigurationMenu } from "@raiden/library/hooks/useConfigurationMenu";
import { MenuItem } from "./MenuItem";

/**
 * @typedef {Object} Props
 * @property {() => void} onClickMenu
 */
/**
 * @param {Props} props
 */
export function MenuMobile({ onClickMenu }) {
  const { menu } = useConfigurationMenu({ alias: "header" });

  return (
    <Box>
      {menu && menu.items.length > 0 && (
        <>
          {menu.items.map((item, index) => (
            <MenuItem menuItem={item} onClickMenu={onClickMenu} key={index} />
          ))}
        </>
      )}
    </Box>
  );
}
